import React from "react";
import Tab from "./Tab";
import { Link } from "react-router-dom";

const SolutionsTabs = () => {
  const tabs = [
    {
      label: "Financing",
      content: (
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
              Increase financial predictability of your projects
            </h3>
            <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
              Managing project financing can be a challenge. Manual processes
              often lead to errors and delays, making it difficult to meet
              project deadlines and stay within budget.
            </p>
            <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">
              Estabild streamlines the process, allowing for quick and easy draw
              request and payment approvals, real-time finance monitoring, and
              informed decisions with dashboards and reports.
            </p>
            <Link
              to="/solutions/funding"
              className="text-primary-600 font-semibold hover:text-primary-700 transition-colors inline-flex items-center gap-2 text-sm sm:text-base"
            >
              Predictable Funding →
            </Link>
          </div>
          <div className="h-64 sm:h-80 lg:h-96">
            <img
              src="/home/audience/6561ad8e5d147dda237af58f_Rectangle 1661.png"
              alt="Financial Predictability"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      ),
    },
    {
      label: "Execution",
      content: (
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Get complete project performance overview
            </h3>
            <p className="text-gray-600 mb-4">
              The lack of a comprehensive and connected view in a project leads
              to undesired outcomes such as delays, budget overruns or claims.
            </p>
            <p className="text-gray-600 mb-6">
              Estabild helps you have all key data in place and ensures that
              your development projects get executed according to the
              established business plan.
            </p>
            <Link
              to="/solutions/execution"
              className="text-primary-600 font-semibold hover:text-primary-700 transition-colors inline-flex items-center gap-2"
            >
              Complete Execution Management →
            </Link>
          </div>
          <div className="h-96">
            <img
              src="/home/audience/6561ad8e855e506cb34c6327_Rectangle 1661-1.png"
              alt="Development"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      ),
    },
    {
      label: "Renovation",
      content: (
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Reduce the risk of delays with streamlined team communication
            </h3>
            <p className="text-gray-600 mb-4">
              Chasing for updates over email, in recurrent meetings and sharing
              news with onsite flyers is inefficient and time-consuming.
            </p>
            <p className="text-gray-600 mb-6">
              Estabild ensures alignment among key stakeholders, organized
              project documentation, and keeps property occupiers up to date.
            </p>
            <Link
              to="/solutions/planning"
              className="text-primary-600 font-semibold hover:text-primary-700 transition-colors inline-flex items-center gap-2"
            >
              Streamlined Renovation Process →
            </Link>
          </div>
          <div className="h-96">
            <img
              src="/home/audience/6561ad8e7b842e7a4b8ec47d_Rectangle 1661-2.png"
              alt="Planning"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container-custom">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-4 px-4">
          Enable reliable and predictable outcomes for your business
        </h2>
        <div className="mt-8 sm:mt-12">
          <Tab tabs={tabs} />
        </div>
      </div>
    </section>
  );
};

export default SolutionsTabs;
